import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { KeycloakGuard } from '@badgertechnologies/liblogin.js';
import { betaAccessGuardFn, initialRoleRedirectGuardFn, roleGuardFn } from '@ng-cloud/badger-core/common/guards/functional-guards';
import { ThemeBuddyComponent } from './theme-buddy/theme-buddy/theme-buddy.component';
import { OrganizationDnaComponent } from './badger-dna/organization-dna/organization-dna.component';
import { StoresComponent } from './store/stores/stores.component';

const routes: Routes = [
  {
    path: 'queued-base-scans',
    loadChildren: () => import('./base-scan-queue/base-scan-queue.module').then(m => m.BaseScanQueueModule),
    data: { roles: ['admin', 'realogram_editor'] },
    canMatch: [roleGuardFn],
    canActivate: [KeycloakGuard]
  },
  {
    path: 'stores',
    loadChildren: () => import('./store/store.module').then(m => m.StoreModule),
    data: { roles: ['user', 'client_portal', 'auditor', 'insight_auditor', 'external_insight_auditor', 'realogram_editor'] },
    canMatch: [roleGuardFn],
    canActivate: [KeycloakGuard]
  },
  {
    path: 'dna',
    component: OrganizationDnaComponent,
    data: { roles: ['Organization Executive', 'Regional Manager'] },
    canMatch: [roleGuardFn, betaAccessGuardFn],
    canActivate: [KeycloakGuard]
  },
  {
    path: 'themes',
    component: ThemeBuddyComponent,
    data: { roles: ['admin'] },
    canMatch: [roleGuardFn],
    canActivate: [KeycloakGuard]
  },
  {
    path: 'reports',
    loadChildren: () => import('./report/report.module').then(m => m.ReportModule),
    data: { roles: ['user', 'client_portal'] },
    canMatch: [roleGuardFn],
    canActivate: [KeycloakGuard]
  },
  {
    path: 'users',
    loadChildren: () => import('./user/user.module').then(m => m.UserModule),
    canActivate: [KeycloakGuard]
  },
  { path: '', pathMatch: 'full', component: StoresComponent , canActivate: [initialRoleRedirectGuardFn] },
  { path: 'restricted', redirectTo: '/' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})]
})
export class AppRoutingModule {
}
